import type { AddFieldPlacementTarget } from '@cli-types/core-engine/add-field.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { promptSelectValue } from './prompt-select-value.js'

export async function promptInsertionOrder(
  context: SchemaPromptContext,
  target: AddFieldPlacementTarget
): Promise<{
  before?: string
  after?: string
}> {
  const fields = target.getFields()
  const namedFields = fields
    .map((field) => field.name)
    .filter((name): name is string => typeof name === 'string' && name.length > 0)

  if (namedFields.length === 0) {
    return {}
  }

  const order = await promptSelectValue(context, 'Where in that target?', [
    { value: 'end', label: 'End' },
    { value: 'before', label: 'Before field' },
    { value: 'after', label: 'After field' }
  ] as const)

  if (order === 'end') {
    return {}
  }

  const field = await promptSelectValue(
    context,
    order === 'before' ? 'Insert before which field?' : 'Insert after which field?',
    namedFields.map((name) => ({ value: name, label: name }))
  )

  return order === 'before' ? { before: field } : { after: field }
}
